import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  Observable,
  catchError,
  retry,
  throwError,
} from 'rxjs';
import { IAppConfig } from '../shared/interfaces/app-config';
import { AppConfigService } from './app-config.service';
import { environment } from '../shared/constants/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  config: IAppConfig;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
  ) {
    this.config = this.appConfigService.getConfig();
  }

  getUserInfo() {
    return this.http
      .get<any>(`${this.config.apiUrl}/User/user`)
      .pipe(catchError(this.handleError));
  }

  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    
    // this.userInfoService.getManager().signinRedirect();
    return throwError(() => {
      return errorMessage;
    });
  }
}
